<template>
    <b-container class="mb-5">
       <PageHeader :linkto="'/Payment/Home'" :linkttitle="'返回'" title=""></PageHeader>
        <b-container >
            <b-card  class="text-center">
                <b-img :src="require('@/assets/ui/finish.svg')" width="300px" fluid alt="Fluid image"></b-img>
                <h3 class="text-success">完成付款</h3>
                <p class="text-muted">訂單編號：{{ paySuccessData.MerchantTradeNo }}</p>
                <p class="text-muted">付款金額：{{ paySuccessData.TradeAmt }}</p>
                <p class="text-muted">付款時間：{{ paySuccessData.PaymentDate }}</p>
                <p class="text-muted">付款方式：信用卡</p>
                <b-button variant="outline-primary" to="/Home">返回服務項目</b-button>
            </b-card>
        </b-container>


       <AnaLoading :show="pageloading"></AnaLoading>
    </b-container>
</template>
<script>
import {mapState} from 'vuex'
import PageHeader from '@/components/PageHeader.vue'
import AnaLoading from '@/components/AnaLoading.vue'
import { toastsModel } from '@/service/commuse'

export default {
  name: 'Ecpay',
  components: {PageHeader,AnaLoading},
  data () {
    return {
      pageloading:true,
      paySuccessData:{
        MerchantTradeNo:'',
        TradeAmt:'',
        PaymentDate:''

      },
      trandno:''


    }
  },
  mounted () {

    this.trandno = this.$route.params.tradeno
    this.$store.dispatch('actionGetTrandno', {
      trandno:this.$route.params.tradeno
    }).then((res) => {
      this.paySuccessData.MerchantTradeNo = res.data[0].trandno
      this.paySuccessData.TradeAmt = res.data[0].amount
      this.paySuccessData.PaymentDate = res.data[0].payment_date
      this.pageloading = false
    }).catch(()=>{
      this.$router.push('/Payment/PlanCart');

    })


  },
  methods: {

  }
}
</script>

